import React from "react";
const  AgreementText = <React.Fragment>
   <div className="agreement-text">
<p align="center">
    <strong><u>USER LICENSE &amp; CONFIDENTIALITY AGREEMENT</u></strong>
</p>
<p>
This User License &amp; Confidentiality Agreement (the “<strong>Agreement</strong>”) is a legal agreement between    <strong> Tesseract Imaging Limited</strong>, a public company limited by
    shares incorporated in India under Companies Act, 2013, having its
    registered office at 44/4, Shivaji Chowk, Mulund Colony, Mulund (W) Mumbai
400 082 (herein after referred to as “<strong>Tesseract</strong>”); and<strong> You </strong>(hereinafter referred to as the “    <strong>Licensee</strong>” or “<strong>You</strong>”). You and Tesseract
    are hereinafter individually referred to as the “<strong>Party</strong>”
    and collectively referred to as the “<strong>Parties</strong>”.
</p>
<p>
    Please read the terms of this Agreement carefully before downloading the
    Jio Mixed Reality Development Tools which includes the Jio Mixed Reality
    SDK and documentation (“<strong>SDK</strong>”), design (UI/UX) toolkits and
    documentation, the JioGlass companion application and other resources
    (collectively referred to as the “<strong>Development Tools</strong>”)
    offered by Tesseract.
</p>
<p>
    If You do not understand the provisions of this Agreement or do not accept
    or agree to any part of them, then You should not use the Development
    Tools. This Agreement is an electronic record in terms of the Information
    Technology Act, 2000 (as amended / re-enacted) (“<strong>IT Act</strong>")
    and are published in accordance with the provisions of Rule 3 (1) of
    Information Technology (Intermediaries Guidelines and Digital Media Ethics
    Code) Rules, 2021 (“<strong>Intermediaries Rules 2021</strong>”) that
    require publishing of the rules and regulations, privacy policy and terms
    of use for access to or usage of the Development Tools and electronic
    resource. In addition, some services offered through the Development Tools
    may be subject to additional terms and conditions specified by Tesseract
    from time to time; Your use of such services is subject to those additional
    terms and conditions, which are incorporated into this Agreement by
    reference and notified to You from time to time, including but not limited
to the terms and conditions made available at <a href="https://tesseract.in/terms-condition/" target="_blank" rel="noopener noreferrer">https://tesseract.in/terms-condition/</a>.
    This Agreement sets forth the legally binding terms and conditions for Your
    use of the Development Tools.
</p>
<p>
    Tesseract reserves the right, at its sole discretion, to change, modify,
    add, or remove portions of this Agreement and Tesseract will notify You of
    such changes periodically. Your continued performance of the obligations as
    contemplated hereunder, following any modifications as may be notified to
    You, will mean Your deemed acceptance to such modifications. By clicking on
    ‘I Accept’, You hereby represent and warrant to Tesseract that:
</p>
<p>
    i. You are legally competent to enter into a contract and have the right
    and authority to enter into this Agreement on Your own behalf, or if You
    are entering into this Agreement on behalf of a legal person (having a
    valid corporeal existence and competence to contract, under applicable law
    in India), You have the right and authority to legally bind such person to
    the terms and obligations of this Agreement;
</p>
<p>
    ii. You will comply with the terms of and fulfill Your obligations under
    this Agreement, including obtaining any required consents for personnel or
    authorised representatives for use of the Development Tools provided by
    Tesseract under this Agreement, and You agree to monitor and be fully
    responsible for all such use by Your personnel and authorised
    representatives and their compliance with the terms of this Agreement;
</p>
<p>
    iii. You will be solely responsible for all costs, expenses, losses and
    liabilities incurred, and activities undertaken by You in connection with
    the Development Tools and other facilities provided by Tesseract under this
    Agreement, and Your related development and distribution efforts,
    including, but not limited to, any related development efforts, network and
    server equipment, internet service(s), or any other hardware, software or
    services used by You in connection with Your use of the Development Tools
    thereof;
</p>
<p>
    iv. You will not act in any manner which conflicts or interferes with any
    existing commitment or obligation You may have and no agreement previously
    entered into by You will interfere with Your performance of Your
    obligations under this Agreement.
</p>
<p>
    <strong>1. </strong>
    <strong><u>Scope.</u></strong>
</p>
<p>
    Tesseract inter-alia<em> </em>is engaged in the business of developing
    software and hardware in the augmented, virtual and mixed reality sphere
    <a name="_Ref8723432">
        and has determined to make available Development Tools to individuals
        and entities who intend on developing applications, content and
        software for Jio AR/VR/MR devices
    </a>
    <em> </em>
    (“<strong>Purpose</strong>”) using the Development Tools, including the
    SDK. In view of the foregoing, the Parties intend to set forth the terms
    and conditions of License (<em>as defined hereinafter) </em>and certain
    other respective rights and obligations in connection with the License.
</p>
<p>
    <strong>2. </strong>
    <strong><u>Grant of License; Term.</u></strong>
</p>
<p>
    <a name="_Ref8645150"></a>
    <a name="_Hlk41055017"></a>
    <a name="_Ref54013219">
        2.1 Subject to the terms of this Agreement, Tesseract grants You, a
        limited, non-exclusive, personal, non-transferrable, non-sublicensable
        and revocable license (“<strong>License</strong>”) to use the SDK and
        Development Tools available at <a href="https://tesseract.in/" target="_blank" rel="noopener noreferrer">https://tesseract.in/</a>. Tesseract</a> reserves for itself all other rights and interest not explicitly granted
    under this Agreement.
</p>
<p>
    2.2 You hereby acknowledge that any data, information or service provided
    by any third party entities on the Development Tools, would not be governed
    by this Agreement, and You would be bound by the respective terms of use,
    trade and service or privacy policy of such third-party entities. Tesseract
    neither provides any representation nor guarantee in relation to such
    services and data provided by the third-party entities on the Development
    Tools.
</p>
<p>
    <a name="_Ref8725245">2.3 The License granted under the above Clause </a>
    2.1 is only for Your limited use of the Development Tools, including the
    SDK, specifically for the Purpose and for any other purposes approved in
    writing by Tesseract and shall not include, without limitation, the right
    to:
</p>
<p>
    a) license, sublicense, sell, resell, transfer, assign, distribute or
    otherwise commercially exploit or make available to any third party the
    Development Tools, any constituents of the Development Tools or any
    products developed using the Development Tools, in any way;
</p>
<p>
    b) circumvent, modify or disable any security or other technical features
    of the Development Tools;
</p>
<p>
    c) create internet “links” to the Development Tools or any constituents of
    the Development Tools or “frame” or “mirror” any content on any other
    server or wireless or internet-based device;
</p>
<p>
    d) reverse engineer any constituents of the Development Tools for any
    purpose whatsoever, including without limitation, to (i) build a
    competitive product or service; (ii) build a product using similar ideas,
    features, functions or graphics of the constituents of the Development
    Tools; (iii) copy any ideas, features, functions or graphics of the
    constituents of the Development Tools; (iv) use any other software or
    design on Your equipment that can conduct robotic process automations and
    threaten the compilation of data of the Development Tools; or (v)
    show/allow the constituents of the Development Tools to be accessed or
    discovered by other software installed on Your equipment that would
    threaten or disrupt the Development Tools, provided herein.
</p>
<p>
    2.4 The Agreement and/or the License shall be valid from the date You click
    on the “I Accept” as provided hereunder (“<strong>Effective Date</strong>
    ”), until expressly revoked by Tesseract (the “<strong>Term</strong>”).
</p>
<p>
    <a name="_Ref8654848">
        <strong>3. </strong>
        <strong><u>License, implementation and use of the </u></strong>
    </a>
    <strong><u>Development Tools.</u></strong>
</p>
<p>
    3.1 You agree that Tesseract shall be entitled, to deal with the
    Development Tools in any manner that it deems fit, including providing
    services such as any variation, Update or improvement thereof to any third
    party, from time to time. “<strong>Update</strong>” means the modifications
    or revisions, updates made to the SDK and/ or the Development Tools for any
    reason whatsoever, including for compliance with any laws or operations of
    the SDK and/ or the Development Tools, other than a New Release.
</p>
<p>
    3.2 The Development Tools may include all modifications, Updates, future or
    New Releases, additions, versions (whether new or modified), at the sole
    discretion of Tesseract. The Licensee’s continued use of the Development
    Tools pursuant to any such Updates and New Releases will be its deemed
    acceptance of such Updates and New Releases. Tesseract reserves the right
    to provide such Updates or New Releases at an additional cost or by way of
a separate licensing agreement. For the purposes of this Agreement, “    <strong>New Release</strong>” means a new version of the existing SDK and/
    or the Development Tools that may change the version number of such SDK or
    the relevant Development Tool.
</p>
<p>
    3.3 You acknowledge and agree that any data or information that You share
    with Tesseract during the Term shall be stored in Tesseract’s system/server
    until termination of this Agreement. It is hereby clarified that after the
    termination of this Agreement, all such data or information shall be erased
    from Tesseract’s system/server. You shall be responsible for any consents
    that are required to be provided or maintained for the collection, storage
    and accessing of the personal information as per applicable laws.
</p>
<p>
    3.4 You hereby agree and undertake not to use any of the Development Tool
    or any components of the Development Tools for any purpose other than the
    Purpose and to use the relevant Development Tool or any components of the
    Development Tools in due and satisfactory compliance of the terms contained
    in this Agreement and all applicable laws.
</p>
<p>
    3.5 You hereby undertake to not use any of the Development Tool or any
    components of the Development Tools in any manner that would:
</p>
<p>
    (a) pose as a security risk to Tesseract, its affiliates or any third
    party;
</p>
<p>
    (b) adversely impact Tesseract’s other services and products;
</p>
<p>
    (c) subject Tesseract or its affiliates to any liability; or
</p>
<p>
    (d) be fraudulent.
</p>
<p>
    3.6 The provisions of this Clause 3 constitute a material term under this
    Agreement; the breach of which by You shall constitute breach and
    termination of this Agreement hereof.
</p>
<p>
    <strong>4. </strong>
    <strong>
        <u>
            Tesseract’s right to suspend Licensee’s access to the Development
            Tools or terminate this Agreement.
        </u>
    </strong>
    <strong><u></u></strong>
</p>
<p>
    Tesseract shall have the right to suspend Your right to access or use any
    portion or all of the Development Tools and/or terminate this Agreement, at
    any time, without any prior notice. <strong><em> </em></strong>
</p>
<p>
    <a name="_Ref10034200">
        <strong>5. </strong>
        <strong><u>Confidentiality</u></strong>
    </a>
    <strong><u>.</u></strong>
    <strong><u> </u></strong>
    <strong><u></u></strong>
</p>
<p>
    5.1 You shall keep the Confidential Information strictly confidential and
    shall not disclose, or permit disclosure of Confidential Information, to
    any third party; or allow any third party to copy, modify, update or edit
    the Confidential Information. You shall protect the Confidential
    Information by using a reasonable degree of care, to prevent the
    unauthorized use or disclosure of the Confidential Information.
</p>
<p>
    5.2 You shall restrict disclosure of Confidential Information only to those
    employees who have a need to know such Confidential Information, solely in
    connection with performance of duties pursuant to this Agreement.
</p>
<p>
    5.3 The confidentiality obligations shall not apply to information which is
    (a) now in or hereafter enters the public domain without a breach of this
    Agreement; (b) known to You prior to disclosure by Tesseract; (c) disclosed
    by You with the prior written approval of Tesseract; or (d) which is
    required to be disclosed by law, a government agency or an order of a
    court, provided that You shall provide a prior written notice to Tesseract
    (to the extent legally permitted) so as to enable Tesseract to obtain an
    appropriate protective order limiting such disclosure.
</p>
<p>
    5.4 You agree to protect Confidential Information using at least the same
    degree of care that You use to protect Your own confidential information of
    similar importance, but no less than a reasonable degree of care. You agree
    to use Confidential Information solely for the purpose of exercising Your
    rights and performing Your obligations under this Agreement and agree not
    to use Confidential Information for any other purpose, for Your own or any
    third party’s benefit, without Tesseract's prior written consent. You
    further agree not to disclose or disseminate Confidential Information to
    anyone other than: (i) those of Your employees and authorised
    representatives, who have a need to know and who are bound by a written
    agreement that has terms substantially similar to those set out hereunder
    and prohibit unauthorized use or disclosure of the Confidential
    Information; or (ii) except as otherwise agreed or permitted in writing by
    Tesseract. You acknowledge that damage owing due to improper use or
    disclosure of Confidential Information may be irreparable, the degree of
    which may be difficult to ascertain; therefore, Tesseract is entitled to
    seek relief, including injunction and preliminary injunction, in addition
    to all other rights and remedies available at law or in equity.
</p>
<p>
    5.5 Upon Tesseract’s request, You shall return or destroy all copies of the
    Confidential Information, other proprietary material and any copies thereof
    and provide a written certification to Tesseract that all Confidential
    Information has been either returned or destroyed. The confidentiality
    obligations shall be perpetual and survive the suspension of License or
    termination of this Agreement.
</p>
<p>
5.6 For the purposes of this Agreement, “<strong>Confidential</strong>    <strong> I</strong><strong>nformation</strong>” shall mean any and all
    information disclosed by Tesseract to You, whether in writing or orally,
    irrespective of whether it is designated as confidential. “Confidential
    Information” shall also include proprietary or confidential information of
    a third party that Tesseract may disclose to You hereunder, any
    Intellectual Property (<em>defined below</em>) including any copyright,
    algorithms, software programs, and formulae related to the current, future
and proposed products and services of Tesseract, any data compilations    <a name="_Hlk54804076">, </a>device specifications, business model details
    and any market growth strategy and projections provided by Tesseract.
</p>
<p>
    <a name="_gjdgxs"></a>
    <strong>6. </strong>
    <strong><u>Intellectual Property Rights.</u></strong>
</p>
<p>
    6.1 “<strong>Intellectual Property</strong>” means and includes all
    intellectual property, in any part of the world, whether registered or not
    registered, and includes (i) all trademarks, patents, copyrights and
    software including source code, computer programs, user interfaces,
    software applications, software platform or infrastructure and any other
    information in relation to the above; (ii) all rights under licenses in
    respect of all of the above; (iii) any applications or registrations for
    the protection of all of the rights specified at sub-clause (i) and (ii)
    herein above; and (iv) all renewals and extensions thereof; and the term
    “Intellectual Property Rights” shall be construed accordingly.
</p>
<p>
    6.2 All Intellectual Property Rights in and title to the Development Tools
    or constituents of the Development Tools, the present or future
    modifications / upgradations thereof, Updates and New Releases shall
    unconditionally remain under the exclusive ownership of Tesseract. This
    Agreement does not and shall not transfer any ownership or proprietary
    interest in the Development Tools or any constituents of the Development
    Tools from Tesseract to You.
</p>
<p>
    6.3 You understand and acknowledge that the License granted herein pertains
    to the Development Tools solely developed by Tesseract or its affiliates
    and does not include a license to any third-party software or Intellectual
    Property. You shall be solely responsible for obtaining and maintaining
    such third<a name="_DV_M86"></a>-party software and its Intellectual
    Property Rights, at its sole cost and expense. In the event You
    subsequently desire to license or deal in any other manner with any other
    software developed by Tesseract, then the Parties will negotiate in good
    faith to determine the terms upon which Tesseract will agree to license or
    deal with any of same to You.
</p>
<p>
    6.4 Tesseract and/ or its affiliates retains all rights, title, and
    interest in and to the Development Tools it may make available to You under
    this Agreement. You agree to cooperate with Tesseract to maintain
    Tesseract's and/ or its affiliates ownership of the Development Tools, and,
    to the extent that You become aware of any claims relating to the
    Development Tools, You agree to use reasonable efforts to promptly provide
    notice of any such claims to Tesseract.
</p>
<p>
    6.5 You shall not contest the validity or ownership of the Intellectual
    Property of Tesseract. You agree to promptly notify Tesseract in writing,
    of any (i) actual or threatened infringement of Tesseract’s Intellectual
    Property; or (ii) claims, allegation, complaint or notices arising in
    connection with Tesseract’s Intellectual Property provided hereunder and
    shall do such acts as may be reasonably requested by Tesseract in this
    regard. <strong><em> </em></strong>
</p>
<p>
    6.6 You undertake to seek and obtain all necessary licenses and/or
    authorisations to use any third-party Intellectual Property while using the
    Development Tools for the Purpose. Tesseract shall have the right to audit
    Your premises, procedures and records that relate to the Development Tools
    to ensure compliance with this Clause 6.6 and You shall provide full
    co-operation to Tesseract for the same.
</p>
<p>
    6.7 You represent, warrant, covenant and agree that You shall not do any
    act, deed, matter or thing whatsoever which may, or is likely to, adversely
    affect or prejudice, directly or indirectly, Tesseract’s title, interest,
    right, power or authority in or in relation to or in respect of Tesseract’s
    Intellectual Property. You shall not during the Term or anytime thereafter
    contest or aid others in contesting the validity, ownership or right to use
    of Tesseract’s Intellectual Property.
</p>
<p>
    6.8 The Parties hereby agree and acknowledge that each Party shall continue
    to retain absolute ownership of all Intellectual Property, proprietary
    information and material in which such Party has proprietary rights, prior
    to and/or independent of this Agreement, and shall continue to be the sole
    and exclusive property of such Party at all times.
</p>
<p>
    <strong>7. </strong>
    <strong><u>Indemnification.</u></strong>
    <strong></strong>
</p>
<p>
    You agree and undertake to defend, indemnify and hold harmless Tesseract
    and its officers, directors, employees, agents, representatives, group
    companies and affiliates from and against any and all expenses, damages,
    claims, suits, actions, judgments and costs, whatsoever, including
    attorney’s fees, arising out of, or in any way connected with (a) breach of
    the terms of this Agreement and the License granted hereunder; (b) breach
    of any representations, warranties or covenants in connection with this
    Agreement; (c) breach of the confidentiality obligations under this
    Agreement by You; (d) infringement of any third parties’ Intellectual
    Property rights by You; (e) Your use of the Development Tools or any of its
    components, including where such use is in a manner not authorised by this
    Agreement; and (f) gross negligence, wilful misconduct or fraud by You in
    the performance of Your obligations under this Agreement.
</p>
<p>
    <strong>8. </strong>
    <strong>
        <u>
Your Representations, Warrantie<a name="_DV_C29"></a><a name="_Toc268772572"></a>            <a name="_Toc269897001">s and Covenants.</a>
        </u>
    </strong>
    <strong></strong>
</p>
<p>
    <a name="_Ref223238206"></a>
    <a name="_DV_M110"></a>
8.1 You represent and warrant to Tesseract that:    <a name="_Ref223238248"></a>
</p>
<p>
    (a) the Development Tools provided under this Agreement has been downloaded
    by You based on its general conformance to the needs identified by You;
</p>
<p>
    (b) You have evaluated all the risks associated with the use and License of
    the Development Tools and accept the entire risk associated with such use
    and License;
</p>
<p>
    (c) You shall not use the Development Tools or any of its constituents so
    as to breach any applicable law;
</p>
<p>
    (d) all data made available or provided by You to Tesseract in connection
    with use of the Development Tools or otherwise during the Term, is in
    strict compliance with all applicable data protection and privacy laws;
</p>
<p>
    (e) You have not infringed upon the Intellectual Property Rights of any
    third parties in direct or indirect connection with the use of the
Development Tools or any of its constituents<a name="_DV_M114"></a>    <a name="_DV_M115"></a><a name="_DV_M116"></a>;
</p>
<p>
    (f) You shall instruct Your affiliates, users, employees, contractors,
    agents, or sub-licensees, or their employees, contractors and agents
    permitted to use the Development Tools of the foregoing obligations and
    prohibitions;
</p>
<p>
    (g) You covenant that You shall not use the Development Tools in any manner
    that could impair, dilute, or tend to impair or adversely affect the
    reputation and relationship of Tesseract with third parties; and
</p>
<p>
    (h) You are at least 18 years of age and if under 18 years of age, have
    entered into this Agreement through a parent or a legal guardian.
</p>
<p>
    8.2 You agree to inform Tesseract immediately if any statement set forth in
    Clause 8.1 ceases to be true and correct as of any date after the Effective
    Date hereof. <strong><em> </em></strong>
</p>
<p>
    8.3 By using the Development Tools, You hereby agree to ensure that the
    explicit prohibitions mentioned in Clause 8.4 are at all times adhered to.
</p>
<p>
    8.4 You shall not use the Development Tools to host, display, upload,
    modify, publish, transmit, update or share any information which:
</p>
<p>
    (a) Belongs to another person and to which You do not have any right;
</p>
<p>
    (b) Is grossly harmful, harassing, blasphemous, defamatory, obscene,
    pornographic, pedophilic, libelous, invasive of another’s privacy, hateful,
    or racially, ethnically objectionable, disparaging, relating or encouraging
    money laundering or gambling or otherwise unlawful in any manner
    whatsoever; or unlawfully threatening or unlawfully harassing including but
    not limited to “indecent representation of women” within the meaning of the
    Indecent Representation of Women (Prohibition) Act 1986;
</p>
<p>
    (c) Is misleading in any way;
</p>
<p>
    (d) Is patently offensive to the online community, such as sexually
    explicit content, or content that promotes obscenity, pedophilia, racism,
    bigotry, hatred or physical harm of any kind against any group or
    individual;
</p>
<p>
    (e) Harasses or advocates harassment of another person;
</p>
<p>
    (f) Involves the transmission of “junk mail”, “chained letters”, or
    unsolicited mass mailing or “spamming”;
</p>
<p>
    (g) Promotes illegal activities or conduct that is abusive, threatening,
    obscene, defamatory or libelous;
</p>
<p>
    (h) Infringes upon or violates any third party’s rights (including, but not
    limited to, intellectual property rights, rights of privacy or rights of
    publicity);
</p>
<p>
    (i) Promotes an illegal or unauthorized copy of another person’s
    copyrighted work;
</p>
<p>
    (j) Provides instructional information about illegal activities such as
    making and/ or buying illegal weapons, violating someone’s privacy, or
    providing or creating computer viruses;
</p>
<p>
    (k) Solicits gambling or engages in any gambling activity which we in our
    sole discretion believe is or could be construed to be as illegal;
</p>
<p>
    (l) Harms minors in any way;
</p>
<p>
    (m) Violates any law for the time being in force;
</p>
<p>
    (n) Impersonates another person;
</p>
<p>
    (o) Contains software viruses or any other computer code, files or programs
    designed to interrupt, destroy or limit the functionality of any computer
    resource; or contains any trojan horses, worms, time bombs, cancelbots,
    easter eggs or other computer programming routines that may damage,
    detrimentally interfere with, diminish value of, surreptitiously intercept
    or expropriate any system, data or personal information; and
</p>
<p>
    (p) Threatens the unity, integrity, defense, security or sovereignty of
    India, friendly relations with foreign states, or public order or causes
    incitement to the commission of any cognizable offense or prevents
    investigation of any offense or is insulting any other nation.
</p>
<p>
    8.5 In no event may You enter into any settlement or like agreement with a
    third party that affects Tesseract's rights or binds Tesseract in any way,
    without the prior written consent of Tesseract.
</p>
<p>
    <a name="_Toc268772575"></a>
    <a name="_Toc269897004"></a>
    <a name="_Toc386626514">
        <strong>9. </strong>
        <strong><u>Disclaimers</u></strong>
    </a>
    <strong><u> by </u></strong>
    <strong><u>Tesseract.</u></strong>
</p>
<p>
    <a name="_Toc268772576"></a>
    <a name="_Toc269897005">
        <strong>9.1 </strong>
        <strong>General Disclaimer</strong>
    </a>
    <strong></strong>
</p>
<p>
    Due to the vagaries that can occur in the electronic distribution of
    information and due to the limitations inherent in the use of the internet
    and other electronic communications, the access and use of the Development
    Tools or any constituents thereof may be subject to limitations, delays,
    omissions and such other problems incidental thereto.
</p>
<p>
    <a name="_Toc268772577"></a>
    <a name="_Toc269897006">
        <strong>9.2 </strong>
        <strong>Disclaimer of Warranties</strong>
    </a>
    <strong></strong>
</p>
<p>
    <strong></strong>
</p>
<p>
    9.2.1 The access and use of the Development Tools shall be provided on an
    “as is” and “as available” basis with all faults and without any warranty
    of any kind and any implied warranty of merchantability, purpose, quality,
    accuracy, title, timeliness, fitness for a particular purpose, or
    non-infringement of third-party rights are hereby disclaimed to the full
    extent permitted by applicable law by <a name="_DV_M72"></a>Tesseract. It
    is hereby clarified that Tesseract does not warrant against interference
    with the use of the Development Tools. Tesseract does not warrant that the
    Development Tools or any constituents thereof is error-free or that
    operation of any constituents of the Development Tools will be secure or
    uninterrupted. Tesseract exercises no control over and expressly disclaims
    any liability arising out of or based upon Your use of the Development
    Tools or any of its constituents or any third-party services or data being
    accessed or provided under the Development Tools.
</p>
<p>
    9.2.2 TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY
    ACKNOWLEDGE AND AGREE THAT USE OF THE SDK AND DEVELOPMENT TOOLS IS AT YOUR
    SOLE RISK AND THAT THE ENTIRE RISK AS TO SATISFACTORY QUALITY, PERFORMANCE,
    ACCURACY AND EFFORT IS ON YOU. TESSERACT DOES NOT WARRANT THAT ANY
    INFORMATION STORED OR TRANSMITTED THROUGH THE SDK AND DEVELOPMENT TOOLS
    WILL NOT BE LOST, CORRUPTED OR DAMAGED. YOU ACKNOWLEDGE THAT THE SDK AND
    DEVELOPMENT TOOLS ARE NOT INTENDED OR SUITABLE FOR USE IN SITUATIONS OR
    ENVIRONMENTS WHERE ERRORS, DELAYS, FAILURES OR INACCURACIES IN THE
    TRANSMISSION OR STORAGE OF DATA OR INFORMATION BY OR THROUGH THE SDK AND
    DEVELOPMENT TOOLS COULD LEAD TO DEATH, PERSONAL INJURY, OR FINANCIAL,
    PHYSICAL, PROPERTY OR ENVIRONMENTAL DAMAGE. NO ORAL OR WRITTEN INFORMATION
    OR ADVICE GIVEN BY TESSERACT OR A TESSERACT AUTHORIZED REPRESENTATIVE WILL
    CREATE A WARRANTY NOT EXPRESSLY STATED IN THIS AGREEMENT.
</p>
<p>
    <strong>10. </strong>
    <strong><u>LIMITATION OF LIABILITY.</u></strong>
</p>
<p>
    10.1 TO THE EXTENT PERMISSIBLE BY APPLICABLE LAW, IN NO EVENT WILL
    TESSERACT BE LIABLE FOR PERSONAL INJURY, OR ANY INCIDENTAL, SPECIAL,
    INDIRECT, CONSEQUENTIAL OR PUNITIVE DAMAGES WHATSOEVER, INCLUDING, WITHOUT
    LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF DATA, BUSINESS
    INTERRUPTION OR ANY OTHER COMMERCIAL DAMAGES OR LOSSES, ARISING OUT OF OR
    RELATED TO THIS AGREEMENT, YOUR USE OR INABILITY TO USE THE SDK AND
    DEVELOPMENT TOOLS, OR YOUR DEVELOPMENT EFFORTS, HOWEVER CAUSED, WHETHER
    UNDER A THEORY OF CONTRACT, WARRANTY, TORT (INCLUDING NEGLIGENCE), PRODUCTS
    LIABILITY, OR OTHERWISE, EVEN IF TESSERACT HAS BEEN ADVISED OF THE
    POSSIBILITY OF SUCH DAMAGES, AND NOTWITHSTANDING THE FAILURE OF ESSENTIAL
    PURPOSE OF ANY REMEDY. NOTWITHSTANDING ANYTHING CONTAINED HEREIN, IN NO
    EVENT SHALL TESSERACT’S TOTAL LIABILITY TO YOU HEREUNDER FOR ALL DAMAGES
    EXCEED THE AMOUNT OF INR 10,000/- (INDIAN RUPEES TEN THOUSAND ONLY). THE
    FOREGOING LIMITATIONS WILL APPLY EVEN IF THE ABOVE STATED REMEDY FAILS OF
    ITS ESSENTIAL PURPOSE.
</p>
<p>
    <strong><u></u></strong>
</p>
<p>
    <strong>11. </strong>
    <strong><u>Publicity.</u></strong>
    <strong><u></u></strong>
</p>
<p>
    11.1 You hereby consent to the inclusion of Your name and logo in the
    developer lists and marketing materials released or published by Tesseract
    in connection with such promotional and marketing efforts of Tesseract.
</p>
<p>
    11.2 You shall not issue any press releases or make any other public
    statements regarding this Agreement, its terms and conditions, or the
    relationship of the Parties without Tesseract’s express prior written
    approval, which may be withheld at Tesseract’s discretion.
</p>
<p>
    <strong>12. </strong>
    <strong><u>Governing Law and Dispute Resolution.</u></strong>
    <u></u>
</p>
<p>
    This Agreement shall be governed by and construed in accordance with the
    laws of India. All disputes arising in relation to this Agreement shall be
    resolved by a sole arbitrator mutually agreed between the Parties, in
    accordance with the provisions of the arbitration rules of the Indian
    Arbitration and Conciliation Act, 1996 and amendments thereof. The seat of
    arbitration shall be Mumbai and the language shall be English. The order
    passed by the sole arbitrator shall be final and binding on the Parties.
    Notwithstanding anything to the contrary, the Parties may agree to conduct
    the arbitration proceedings virtually through such video conferencing or
other audio-visual means as may be mutually agreed by the Parties.    <strong></strong>
</p>
<p>
    <strong>13. </strong>
    <strong><u>Relationship</u></strong>
    <strong><u> </u></strong>
    <strong><u>of</u></strong>
    <strong><u> Parties and Assignment. </u></strong>
</p>
<p>
    You shall conduct Your business under this Agreement as an independent
    contractor and this Agreement creates no relationship of principal and
    agent, partner, or any similar relationship. The Agreement shall not be
    assigned or transferred by You without the prior consent in writing of
    Tesseract.
</p>
<p>
    <strong>14. </strong>
    <strong><u>Entire</u></strong>
    <strong><u> </u></strong>
    <strong><u>Agreement, Amendment and Waiver. </u></strong>
    <u></u>
</p>
<p>
    This Agreement constitutes the entire agreement of the Parties and
    supersedes all previous communications, either oral or written, between the
    Parties with respect to the said subject matter. No delay or omission to
    exercise any right, upon any breach or default under this Agreement, shall
    be deemed a waiver of any other breach. Any waiver of any provisions of
    this Agreement, must be in writing. Tesseract reserves the right, at its
    sole discretion, to make any amendments to this Agreement and such changes
    will be notified to You as per applicable laws. Your continued performance
    of the obligations as contemplated hereunder, following any modifications
    as may be notified to You, will mean Your deemed acceptance to such
    modifications. <u></u>
</p>
<p>
    <strong>15. </strong>
    <strong><u>Survival.</u></strong>
    <strong><u></u></strong>
</p>
<p>
    The Parties hereby agree and acknowledge that those provisions of this
    Agreement which, by their very nature, should be deemed to survive its
    termination shall survive. Notwithstanding anything herein to the contrary,
    the following provisions shall survive indefinitely (unless otherwise
    indicated) the expiration or termination of this Agreement for any reason:
    Clause 5 (Confidentiality), Clause 6 (Intellectual Property Rights), Clause
    7 (Indemnification), Clause 9 (Disclaimers by Tesseract), Clause 12
    (Governing Law and Dispute Resolution) and this Clause 15 (Survival).
</p>
<p>
    <strong>16. </strong>
    <strong><u>ACCEPTANCE.</u></strong>
</p>
<p>
    BY CLICKING "I ACCEPT" BELOW, YOU AGREE THAT YOU HAVE READ, UNDERSTOOD AND
    EXECUTED THIS AGREEMENT AND THAT YOU WILL BE BOUND BY AND COMPLY WITH ALL
    OF ITS TERMS AND CONDITIONS. DO NOT CLICK THE "I ACCEPT" BUTTON IF YOU DO
    NOT AGREE TO BE BOUND BY THE TERMS AND CONDITIONS OF THIS AGREEMENT.
</p>
</div>
</React.Fragment>;

export default AgreementText;